import styled from 'styled-components';
import OfferDetail from './OfferDetail';
import { colorSchema } from 'utils/style';

export default styled(OfferDetail)`
  height: 100%;
  .offer-detail {
    display: grid;
    grid-gap: 24px;
    grid-template-columns: repeat(14, 1fr);
    height: 100%;

    &__body {
      display: flex;
      flex-grow: 1;
      flex-shrink: 1;
      grid-column: 4 / span 11;
      grid-row: 1;
    }

    &__side-block {
      border-bottom: 1px solid lightgray;
      padding: 2rem 0;
    }

    &__body {
      display: flex;
      width: 100%;
    }

    &__loading {
      display: flex;
      grid-column: 1 / span 14;
      grid-row: 1;
      margin: 2rem 0;
      justify-content: center;
      width: 100%;
    }

    &__error {
      color: ${colorSchema('error700')};
      display: flex;
      grid-column: 1 / span 14;
      grid-row: 1;
      justify-content: center;
      margin: 2rem 0;
    }
  }
`;
